import {
  VStack,
  SimpleGrid,
  Text,
  Box,
  Button,
  Checkbox,
} from '@chakra-ui/react';
import { useRef, useState } from 'react';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  description?: string;
}

export function ConfirmAcceptModal({
  onCancel,
  onConfirm,
  isLoading,
  description,
}: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [checked, setChecked] = useState(false);

  function onSubmit() {
    onConfirm();
  }

  return (
    <VStack spacing="4">
      <Text fontSize="xl" align="center">
        {description || 'Leia e aceite nossa política de privacidade'}
      </Text>

      <Box
        w="100%"
        h="500px"
        border="1px solid"
        borderColor="gray.200"
        borderRadius="md"
        overflow="hidden"
      >
        <iframe
          ref={iframeRef}
          title="Política de Privacidade"
          src="https://www.dmhealth.com.br/privacy.html"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </Box>

      <Checkbox
        isChecked={checked}
        onChange={e => setChecked(e.target.checked)}
      >
        Li e concordo com a política de privacidade
      </Checkbox>

      <SimpleGrid minChildWidth="180px" spacing="4" w="100%">
        <Button
          isLoading={isLoading}
          disabled={isLoading}
          variant="outline"
          onClick={onCancel}
        >
          Voltar
        </Button>

        <Button
          isLoading={isLoading}
          disabled={isLoading || !checked}
          colorScheme="green"
          onClick={onSubmit}
        >
          Confirmar
        </Button>
      </SimpleGrid>
    </VStack>
  );
}
